import { MenuItem } from '@mui/material';
import CustomEditor from '../utils/CustomEditor';
import '../PostTalent/PostTalentPage.scss'
import CustomSelect from '../utils/customSelect';
import CustomTextField from '../utils/CustomTextField';
import Form from '../utils/Form';
import CustomUnitInput from '../utils/CustomUnitInput';
import CustomRadioInput from '../utils/CustomRadioInput';


function PostJobTemplate({}) {

    const talentCategories = [
        'Proof Reading',
        'Book Editing',
        'Article Editing',
        'Rewriting & Revisions',
        'Technical Editing',
        'Article Editing',
        'Book Editing',
        'Book Editing',
        'Book Editing',
        'Book Editing',
    ];

    const experiences = [
        'Fresher',
        '6 months to 1 year',
        '1 year to 3 years',
        '3 years to 5 years',
        '5 years to 8 years',
        '8 years to 12 years',
        '12 years to 15 years',
        '15 years and above'
    ];

    const noticePeriods = [
        'Immediate', '0 to 30 Days', '30 to 60 Days', '60 to 90 Days'
    ]

    const currencies = [
        {
            symbol: '₹',
            name: 'Rupees'
        },
        {
            symbol: '$',
            name: 'Dollars'
        },
        {
            symbol: '€',
            name: 'Euro'
        },
        {
            symbol: '¥',
            name: 'Yen'
        },
        {
            symbol: '£',
            name: 'Pounds'
        }
    ];

    const states = {
        "tamilnadu": {
            name: 'Tamilnadu',
            cities: ['Chennai', 'Coimbatore', 'Trichy', 'Salem']
        },
        "karnataka": {
            name: 'Karnataka',
            cities: ['Bangalore', 'Hebal', 'Chickmagalore', 'Hampi']
        },
        "maharashtra": {
            name: 'Maharashtra',
            cities: ['Mumbai', 'Pune']
        }
    };

    const formData = {
        title: '',
        description: '',
        skillsNeeded: [],
        salary: {
            amount: '',
            unit: ''
        },
        experience: '',
        noticePeriod: '',
        address: {
            line1: '',
            line2: '',
            pincode: '',
            city: '',
            state: ''
        }
    }

    return (
        <div className="post-job-template-wrp">
            <div className='job-info-wrp'>
                <Form formData={formData} onSubmit={(e,d) => { 
                    console.log(d);
                }} render={(data, onchange) =>
                    <>
                        <div className='title-input-container'>
                            <CustomTextField name='title' label='Title' required className='title-input' placeholder='Title' value={data?.title} inputProps={{ maxLength: 100 }} onChange={onchange} />
                        </div>
                        <div className='title-input-container'>
                            <label>Job Description</label>
                            <CustomEditor onChange={onchange} parent={data} prop='description' value={data?.description}></CustomEditor>
                        </div>
                        <div className='categories-input-wrp'>
                            <label>Skills Needed</label>
                            <CustomSelect parent={data} prop='skillsNeeded' required outerSelection={true} className='skillsNeeded' name='skillsNeeded'
                                options={talentCategories} multiple={true} value={data?.skillsNeeded} onChange={onchange}
                                renderValue={(selected) => 'Select Skills Needed'}
                            />
                        </div>
                        <div className='inputs-wrp'>
                            <CustomUnitInput
                                    label='Salary' placeholder='Salary'
                                    className='salary'
                                    parent={data}
                                    prop='salary'
                                    unit={{
                                        value: data?.salary?.unit,
                                        options: currencies,
                                        prop: 'symbol',
                                        renderValue: (selected) => selected.symbol,
                                        renderOptions: ((c, i) => <MenuItem key={i} value={c}>{c.symbol} - {c.name}</MenuItem>)
                                    }}
                                    amountType = 'text'
                                    amount={data?.salary?.amount}
                                    onChange={onchange}
                                />
                            <div className='unit-input-wrp'>
                                <label>Experience</label>
                                <CustomSelect parent={data} prop='experience' required className='experience' name='experience'
                                options={experiences} value={data?.experience} onChange={onchange}/>
                            </div>
                        </div>
                        <CustomRadioInput parent={data} prop='noticePeriod' label='Notice Period' options={noticePeriods} value={data?.noticePeriod} onChange={onchange} perRow={4}/>
                        <div className='title-input-container'>
                            <CustomTextField name='line1' label='Address Line 1' required className='title-input' placeholder='Enter Street' parent={data.address} prop='line1' value={data?.address?.line1} onChange={onchange} />
                        </div>
                        <div className='title-input-container'>
                            <CustomTextField name='line2' label='Address Line 2' required className='title-input' placeholder='Enter Street' parent={data.address} prop='line2' value={data?.address?.line2} onChange={onchange} />
                        </div>
                        <div className='inputs-wrp address-details'>
                            <CustomTextField name='pincode' type='number' label='Pincode' required className='title-input' placeholder='Enter Pin' parent={data.address} prop='pincode' value={data?.address?.pincode} onChange={onchange} />
                            <div className='address-wrp'>
                                <label>City</label>
                                <CustomSelect parent={data?.address} prop='city' required className='city' name='city'
                                    options={states[data?.state?.toLocaleLowerCase()]?.cities || []} value={data?.address?.city} onChange={onchange} />
                            </div>
                            <div className='address-wrp'>
                                <label>State</label>
                                <CustomSelect parent={data?.address} prop='state' required className='state' name='state'
                                    options={Object.values(states).map(s => s.name)} value={data?.address?.state} onChange={onchange} />
                            </div>
                        </div>
                        <button className='submit-form' type='submit'>Post Job</button>
                    </>
                }></Form>
            </div>
        </div>
    );
};
export default PostJobTemplate;